import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdatePeepMap as UpdatePeepMapMutation,
    UpdatePeepMapVariables,
    PeepMapUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_PEEP_MAP from '../mutations/update-peep-map.graphql';

export const useUpdatePeepMap = (): {
    updatePeepMap: (input: PeepMapUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updatePeepMap, {loading, error}] = useMutation<
        UpdatePeepMapMutation,
        UpdatePeepMapVariables
    >(UPDATE_PEEP_MAP);

    return {
        updatePeepMap: (input: PeepMapUpdateInput) =>
            updatePeepMap({
                variables: {input},
            }),
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
